module.exports = __webpack_public_path__ + "static/bg_043_white_swan-3cd1590bd9fc8534f2272f2f719d3aae.webp";